export default __webpack_public_path__ + "images/7607ba73bd50ebb3938b0fc23f1831d6-do_1.png";